module.exports = __webpack_public_path__ + "static/media/avatar.d340489c.png";